import React from 'react';
import styled from 'styled-components';
const Empty = styled.div `
  position: sticky;
  left: 0;
  top: 0;
  max-width: 100%;
  padding: 12px;
  line-height: 16px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  color: ${({ theme }) => theme.secondary.blendToBackground(700)};
`;
export const EmptyMessage = ({ message }) => {
    return React.createElement(Empty, null, message);
};
//# sourceMappingURL=EmptyMessage.js.map